export default __webpack_public_path__ + "static/media/partners-logo-ewha-w@3x.2c2de305.webp";